import { Pipe, PipeTransform } from "@angular/core";
import * as cc from 'currency-codes';
import getSymbolFromCurrency from 'currency-symbol-map';

@Pipe({ name: 'cc' })
export class CurrencyPipe implements PipeTransform 
{
  transform(value: string): any {
    try {
      if (value) {
        const currency = cc.code(value);
        if (currency) {
          return {
            code: currency.code.toUpperCase(),
            currency: currency.currency,
            digits: currency.digits,
            symbol: getSymbolFromCurrency(currency.code)
          };
        }
      }
      return {code: value ? value.toUpperCase(): value, currency : ""}; // Return null if value is invalid
    } catch (error) {
      return {code:value ? value.toUpperCase(): value, currency : ""}; // Handle unexpected errors gracefully
    }
  }
}
